var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { StyledPopover } from './style';
var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover(props) {
        return _super.call(this, props) || this;
    }
    Popover.prototype.render = function () {
        return React.createElement(StyledPopover, __assign({ basic: true }, this.props));
    };
    Popover.propTypes = {
        on: PropTypes.oneOf(['hover', 'click', 'focus']),
    };
    return Popover;
}(React.Component));
export default Popover;
//# sourceMappingURL=index.js.map